import { render, staticRenderFns } from "./ProdesCaatinga.vue?vue&type=template&id=095793ee&lang=pug"
import script from "./ProdesCaatinga.vue?vue&type=script&lang=js"
export * from "./ProdesCaatinga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports